import Vue from 'vue'
import VueRouter from 'vue-router'
import PeriodicTable from '../components/PeriodicTable.vue'
import StudentFeedback from '../components/StudentFeedback.vue'
import TeamPage from '../components/TeamPage.vue'
// import milestone from '../components/milestone.vue'
import CorporateValue from '../page/CorporateValue.vue'
import PageIndex from '../page/PageIndex.vue'
// import ThesisPage from '../page/ThesisPage.vue'
import NewsDetail from '../page/NewsDetail.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'index',
			component: PageIndex
		},
		{
			path: '/index',
			redirect: '/'
		},
		{
			path: '/CorporateValue',
			name: 'CorporateValue',
			component: CorporateValue
		},
		{
			path: '/PeriodicTable',
			name: 'PeriodicTable',
			component: PeriodicTable,
			meta: {
				keepAlive: true
			}
		},
		{
			path: '/StudentFeedback',
			name: 'StudentFeedback',
			component: StudentFeedback
		},
		{
			path: '/TeamPage',
			name: 'TeamPage',
			component: TeamPage
		},
		{
			path: '/NewsDetail',
			name: 'NewsDetail',
			component: NewsDetail
		}
	]
})